<template>
  <el-dialog
    :title="Lang.tips.alarmConfig"
    append-to-body
    class="global-dialog"
    @close="handelCancel"
    v-model="configBox"
    width="850px"
  >
    <div
      class="add-row"
      style="display: flex; justify-content: space-between; align-items: center; width: 100%"
    >
      <div>
        <!-- <label for="" style="margin-right: 20px;">{{ Lang.Title.modelAlarmSet }}</label> -->
        <comp-button v-if="!isView" icon="add" @click="addDefinition" style="background-color: #fff; border: solid 1px #2684FC;">+ {{ Lang.Button.modelAdd }}</comp-button>
      </div>
      <div>
        <comp-svg name="point-green" size="10px" class="point-green"></comp-svg>
        {{ updateUser }}
      </div>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column label="No" type="index" v-if="!isView"></el-table-column>
      <el-table-column prop="name" :label="Lang.Title.standardPointPoint + '*'">
        <template #header>
          {{ Lang.Title.standardPointPoint }} <span class="required">*</span>
        </template>
        <template #default="{ $index }">
          <el-select
            :disabled="isView"
            v-model="alarmList[$index].sid"
            filterable
            reserve-keyword
            remote
            remote-show-suffix
            :remote-method="getMeasurementPointList"
            :placeholder="isView ? '' : (Lang.tips.plzSelect + ' ' + Lang.Title.standardPointPoint)"
          >
            <el-option v-for="item in measurementPointList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="alarmType"
      >
        <template #header>
          {{ Lang.table.alarmType }} <span class="required">*</span>
        </template>
        <template #default="{ $index }">
          <el-select
            :disabled="isView"
            v-model="alarmList[$index].alarmType"
            filterable
            reserve-keyword
            :placeholder="isView ? '' : (Lang.tips.plzSelect + ' ' + Lang.table.alarmType)"
          >
            <el-option v-for="item in alarmTypeList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="threshold">
        <template #header>
          {{ Lang.Title.modelThreshold }} <span class="required">*</span>
        </template>
        <template #default="{ $index }">
          <el-input
            :readonly="isView"
            maxlength="20"
            v-model="alarmList[$index].alarmVal"
            :placeholder="isView ? '' : (Lang.tips.plzInput + ' ' + Lang.Title.modelThreshold)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="alarmLevel"
      >
        <template #header>
          {{ Lang.label.alarmLevel }} <span class="required">*</span>
        </template>
        <template #default="{ $index }">
          <el-select
            :disabled="isView"
            v-model="alarmList[$index].alarmLevel"
            filterable
            reserve-keyword
            :placeholder="isView ? '' : (Lang.tips.plzInput + ' ' + Lang.label.alarmLevel)"
          >
            <el-option v-for="item in alarmLevelList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="Lang.Title.modelAction" v-if="!isView">
        <template #default="{ $index }">
          <CompIconButton
            type="delete"
            :authorize="true"
            :divider="false"
            @click="removeDefinition($index)"
          ></CompIconButton>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        v-model:current-page="page.currentPage"
        v-model:page-size="page.pageSize"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <template #footer>
      <div style="margin-top: 20px; display: flex; justify-content: center">
        <comp-button style="width: 120px;"  v-if="!isView" @click="handelCancel">{{ Lang.btn.cancel }}</comp-button>
        <comp-button style="width: 120px;" v-if="!isView" type="primary" @click="handleSubmit()">{{ Lang.btn.confirm }}</comp-button>
      </div>
    </template>
  </el-dialog>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue';
import { Lang } from '@/lang/lang';
import { alarmLevels, alarmTypes } from '@/const/options';
import { getModelItemList, itemAlarmPage } from '@/api/gateway/measurementPoint';
import { getDictionary } from '@/api/system/dict';
import { ElMessage } from 'element-plus';
import { validateInt } from '@/utils/validator';


const configBox = defineModel();

const emit = defineEmits(['submit', 'cancel', 'update:alarmList']);

const props = defineProps({
  alarmList: {
    type: Array,
    required: true,
  },
  updateUser: {
    type: String,
    default: '',
  },
  languageOptions: {
    type: Array,
    required: true,
  },
  isView: {
    type: Boolean,
    default: false,
  },
  modelId: {
    type: String,
    default: '',
  },
});

const page = ref({
  currentPage: 1,
  pageSize: 10,
  total: 0,
});



const measurementPointList = ref([]);
const alarmTypeList = ref([]);
const alarmLevelList = ref([]);



// 前端已选的分页数据
const tableData = computed(() => {
  const start = (page.value.currentPage - 1) * page.value.pageSize;
  const end = start + page.value.pageSize;
  return props.alarmList.slice(start, end);
});

function handleSizeChange(size) {
  page.value.pageSize = size;
  page.value.currentPage = 1; // 重置到第一页
}
function handleCurrentChange(val) {
  page.value.currentPage = val;
}


function addDefinition() {
  const newRow = {
    sid: '',
    modelId: props.modelId,
    alarmType: '',
    alarmLevel: '',
    alarmVal: '',
  };
  props.alarmList.push(newRow);
  page.value.total = props.alarmList.length;
  emit('update:alarmList', props.alarmList);
}

function removeDefinition(index) {
  props.alarmList.splice(index, 1);
  emit('update:alarmList', props.alarmList);
}

// 报警配置提交
function handleSubmit() {
  // 校验必填字段
  const missingFields = [];
  props.alarmList.forEach((item, index) => {
    if (!item.sid) {
      missingFields.push({
        index,
        field: Lang.Title.standardPointPoint,
        placeholder: Lang.tips.plzSelect + ' ' + Lang.Title.standardPointPoint,
      });
    }
    if (!item.alarmType) {
      missingFields.push({
        index,
        field: Lang.table.alarmType,
        placeholder: Lang.tips.plzSelect + ' ' + Lang.table.alarmType,
      });
    }
    
    if (!item.alarmVal) {
      missingFields.push({
        index,
        field: Lang.Title.modelThreshold,
        placeholder: Lang.tips.plzInput + ' ' + Lang.Title.modelThreshold,
      });
    }
    if (!/^\d{1,20}(\.\d{1,6})?$/.test(item.alarmVal)) {
      missingFields.push({
        index,
        field: Lang.Title.modelThreshold,
        placeholder: Lang.Title.modelThreshold + ' ' + Lang.tips.plzInputIntNumber,
      });
    }
    if (!item.alarmLevel) {
      missingFields.push({
        index,
        field: Lang.label.alarmLevel,
        placeholder: Lang.tips.plzInput + ' ' + Lang.label.alarmLevel,
      });
    }
  });
  // if (props.alarmList.length < 1) {
  //   return
  // }
  // 如果有未填写的字段，弹出提示
  if (missingFields.length > 0) {
    const firstMissing = missingFields[0];
    ElMessage.error(
      // `${firstMissing.field}: ${firstMissing.placeholder}`
      `${firstMissing.placeholder}`
    );
    return;
    // 如果校验通过，提交数据
  }
  emit('submit');
  
}
function handelCancel() {
  emit('cancel');
}

function getMeasurementPointList() {
  getModelItemList(1, 200, {modelId: props.modelId}).then((res) => {
    if (res.data.code === 200) {
      const list = res.data.data || [];
      measurementPointList.value = list.map(item => ({
        value: item.sid,
        label: item.name,
      }));
    }
  });
}



onMounted(() => {
  if (!props.alarmList.length) {
    addDefinition()
  } else {
    page.value.total = props.alarmList.length;
  }
  getDictionary({code: 'alarmType'}).then((res) => {
    if (res.data.code === 200) {
      const list = []
      res.data.data.map(item => {
        if (!['6','7'].includes(item.dictKey)) {
          list.push({
            value: item.dictKey,
            label: item.i18nValue,
          })
        }
      });
      alarmTypeList.value = list;
    }
  });
  getDictionary({code: 'alarmLevel'}).then((res) => {
    if (res.data.code === 200) {
      alarmLevelList.value = res.data.data.map(item => ({
        value: item.dictKey,
        label: item.i18nValue,
      }));
    }
  });
  getMeasurementPointList()
})
</script>
<style scoped>
.add-row {
  margin-bottom: 10px;
}
.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
.required {
  color: red;
}
</style>
